<script setup>
import { useAppStore } from '@/stores/app'
import { watch, ref } from 'vue'
import { log } from '@/utils/logger'
const appStore = useAppStore()

const props = defineProps({
	name: {
		type: String,
		required: true,
	},
	title: {
		type: String,
		default: '',
	},
	activated: {
		type: Boolean,
		default: false,
	},
	innerFlex: {
		type: Boolean,
		default: false,
	},
})

const isActive = ref(false)

const emit = defineEmits(['active', 'inactive'])

watch(
	() => appStore.currentPage,
	(currentPage) => {
		if (currentPage === props.name) {
			isActive.value = true
			emit('active')
		} else {
			// If page was active and is now not the current page, emit inactive
			if (isActive.value) emit('inactive')
			isActive.value = false
		}
	},
	{ immediate: true },
)
</script>

<template>
	<div class="page" :class="{ [name]: true, active: appStore.currentPage === name || activated, previous: appStore.previousPage === name }">
		<header v-if="$slots.header" @touchstart.passive="appStore.bottomSheet.handleStart" @touchmove.passive="appStore.bottomSheet.handleMove" @touchend.passive="appStore.bottomSheet.handleEnd" @mousedown.passive="appStore.bottomSheet.handleStart" @mouseleave.passive="appStore.bottomSheet.handleEnd">
			<slot name="header"></slot>
		</header>
		<header v-else @touchstart.passive="appStore.bottomSheet.handleStart" @touchmove.passive="appStore.bottomSheet.handleMove" @touchend.passive="appStore.bottomSheet.handleEnd" @mousedown.passive="appStore.bottomSheet.handleStart" @mouseleave.passive="appStore.bottomSheet.handleEnd">
			<div class="label">{{ title ? title : appStore.pageTitle }}</div>
		</header>
		<div class="body" v-momentum-scroll :class="{ innerFlex: innerFlex }">
			<div class="inner" :class="{ innerFlex: innerFlex }">
				<slot></slot>
			</div>
		</div>
		<footer v-if="$slots.footer">
			<slot name="footer"></slot>
		</footer>
	</div>
</template>

<style scoped>
.frame .page .body::-webkit-scrollbar {
	width: 5px;
	background: transparent;
}

.frame .page .body::-webkit-scrollbar-track {
	background: transparent;
}

.frame .page .body::-webkit-scrollbar-thumb {
	background: transparent;
	border-radius: 4px;
	transition: background-color 0.3s ease;
}

.frame .page .body:hover::-webkit-scrollbar-thumb {
	background: rgba(136, 136, 136, 0.3);
}
/*
.frame .page .body.active-scroll::-webkit-scrollbar-thumb {
	background: rgba(136, 136, 136, 0.5);
} */

.frame .page .body .inner {
	padding: 1.5rem;
	padding-right: calc(1rem + 5px);
}

.frame .page .body.has-overflow .inner {
	padding-right: 1rem;
}
</style>
